export const UPDATE_STRIPE_CUSTOMER_CLOUD_FUNCTION = 'updateStripeCustomer' as const;
export const EXECUTE_COMPATIBILITY_CALCULATION_CLOUD_FUNCTION = 'executeCompatibilityCalculation' as const;
export const CONSUME_PROMO_CODE_CLOUD_FUNCTION = 'consumePromoCode' as const;
export const DELETE_USER_CLOUD_FUNCTION = 'deleteUser' as const;
export const GET_USER_PAYMENT_METHODS = 'getUserPaymenthMethods' as const;
export const FINALIZE_STRIPE_PAYMENT_METHOD_CREATION = 'finalizeStripePaymentMethodCreation' as const;
export const UPDATE_CUSTOMER_BILLING_DATA = 'updateStripeCustomer' as const;
export const CREATE_STRIPE_INTENT = 'createStripeSetupIntent' as const;
export const INIT_NEW_PURCHASE_SESSION = 'initNewPurchaseSession' as const;
export const RETRY_PAYMENT_CLOUD_FUNCTION = 'retryPayment' as const;
export const SCHEDULE_SUBSCRIPTION_UPDATE_CLOUD_FUNCTION = 'scheduleSubscriptionUpdate' as const;
export const LOAD_CUSTOMER_TRANSACTIONS_CLOUD_FUNCTION = 'loadCustomerTransactions' as const;
export const INTERRUPT_SUBSCRIPTION_RENEWAL_CLOUD_FUNCTION = 'interruptSubscriptionRenewal' as const;
export const PURCHASE_STRIPE_SUBSCRIPTION_CLOUD_FUNCTION = 'purchaseStripeSubscription' as const;
export const FETCH_STRIPE_PRODUCTS_CLOUD_FUNCTIONS = 'fetchStripeProducts' as const;
export const CREATE_STRIPE_CUSTOMER_CLOD_FUNCTION = 'createStripeCustomer' as const;
